import { render, staticRenderFns } from "./RegionalList.vue?vue&type=template&id=889bb2ac&"
import script from "./RegionalList.vue?vue&type=script&lang=js&"
export * from "./RegionalList.vue?vue&type=script&lang=js&"
import style0 from "./RegionalList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports